'use strict';

import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { isEmpty } from "lodash"

import 'leaflet/dist/leaflet.css';
//import "./stylesMap.css";

const defaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
});

const MapWithMarkers = (props) => {
  const [stores,setStores] = useState([]);
  const [latitude,setLatitude] = useState(0.0);
  const [longitude,setLongitude] = useState(0.0);

  useEffect(() => {
    console.log("[INFO],MapWithMarkers",props.paygoMapList)
    if(!isEmpty(props.paygoMapList)){
      let longitudeAverage = 0.0
      let latitudeAverage = 0.0
      const storeUpdate = props.paygoMapList.map(
          (item)=>{
            longitudeAverage  = longitudeAverage  +  item.longitude
            latitudeAverage  = latitudeAverage  +  item.latitude
            return {
              name: item.boxId,
              position: [item.latitude, item.longitude], // Latitude, Longitude
              link: 'https://www.google.com/maps/search/?api=1&query='+item.latitude+','+item.longitude,
            }
          }
        )
        setLongitude(longitudeAverage/props.paygoMapList.length) 
        setLatitude(latitudeAverage/props.paygoMapList.length)
        setStores(storeUpdate)
    }
  }, []);

  return (
    <MapContainer center={[latitude, longitude]} zoom={3} style={{ height: '100vh', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {stores.map((store, index) => (
        <Marker key={index} position={store.position}  icon={defaultIcon}>
          <Popup>
            <div>
              <h2>{store.name}</h2>
              <a href={store.link} target="_blank" rel="noopener noreferrer">
                Voir sur Google Maps
              </a>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default MapWithMarkers;
